<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('inventory.operation.stock_in.stock_in') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          { text: $t('inventory.operation.stock_in.stock_in'), active: true }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-12 col-md-6 col-lg-8 ts-space-x-2">
            <ts-button
              color="info"
              outline
              @click="$router.push({ name: 'stock-in-create' })"
            >
              {{ $t('add_new') }}
            </ts-button>
            <a-range-picker
              format="DD-MM-YYYY"
              :defaultValue="rangeDate"
              :defaultPickerValue="rangeDate"
              style="width:230px"
              @change="dateRangeChange"
            >
              <template slot="renderExtraFooter"></template>
            </a-range-picker>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4 ts-space-x-2 d-flex">
            <a-select
              style="width: 300px"
              v-model="branch_id"
              :options="branchs"
              showSearch
              mode="multiple"
              :filterOption="
                (input, option) =>
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
              "
              :maxTagCount="1"
              :maxTagTextLength="17"
              :placeholder="$t('all')"
            >
            </a-select>
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              class="mr-2"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :rowGroup="{
            field: 'stock_in_date'
          }"
        >
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">{{ record.branch_name }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.stock_in_number }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.po_number }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.invoice_no }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.supplier_name }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.location_name }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.grand_total }}</td>
            <td class="text-center">
              <a
                href="#"
                v-tooltip="$t('edit')"
                class="mr-2 text-primary"
                @click.prevent="edit(record)"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a
                href="#"
                v-tooltip="$t('pdf')"
                class="mr-2 text-danger"
                @click.prevent="pdfView(record)"
              >
                <i class="fas fa-file-pdf"></i>
              </a>
              <a
                href="#"
                v-tooltip="$t('delete')"
                class="text-danger"
                @click.prevent="destroy(record)"
                :disabled="record._deleting"
              >
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fas fa-trash" v-else></i>
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
      <pdf-preview
        v-model="pdf_view"
        :stock-in-id="stockInId"
        @cancel="value => (pdf_view = value)"
      />
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import moment from 'moment'
import PdfPreview from './component/pdf_preview'

export default {
  name: 'stock-in',
    components: {
    PdfPreview
  },
  data () {
    return {
      loading: false,
      visible: false,
      branchs: [],
      rangeDate: [moment().add(-7, 'Days'), moment()],
      pdf_view: false,
      stockInId: 0,
    }
  },
  computed: {
    ...mapState('stockIn', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.stockIn.search
      },
      set (newValue) {
        this.$store.commit('stockIn/SET_SEARCH', newValue)
        this.$store.commit('stockIn/RESET_CURRENT_PAGE')
      }
    },
    branch_id: {
      get () {
        return this.$store.state.stockIn.branch_id
      },
      set (newValue) {
        this.$store.commit('stockIn/SET_BRANCH_ID', newValue)
      }
    },
    columns () {
      return [
        { name: this.$t('inventory.operation.stock_in.branch') },
        { name: this.$t('inventory.operation.stock_in.stock_in_number') },
        { name: this.$t('inventory.operation.stock_in.po_number') },
        { name: this.$t('inventory.operation.stock_in.reference_invoice') },
        { name: this.$t('inventory.operation.stock_in.supplier/vendor') },
        { name: this.$t('inventory.operation.stock_in.warehouse') },
        { name: this.$t('inventory.operation.stock_in.grand_total') },
        {
          name: this.$t('inventory.operation.stock_in.actions'),
          style: 'text-align:center; width:7%'
        }
      ]
    }
  },
  created () {
    this.branch_id = [this.$store.state.authUser.default_branch_id]
    this.fetchData()
    this.getBranch()
  },
  methods: {
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch(
          'stockIn/fetch',
          Object.assign(
            {
              branch_id: this.branch_id
            },
            { ...attributes }
          )
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    getBranch () {
      this.$store.dispatch('user/getBranch').then(response => {
        this.branchs = response.data.map(el => ({
          value: el.branch_id,
          label: el.branch_name_en
        }))
      })
    },
    edit (record) {
      this.$store.commit('stockIn/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'stock-in-edit',
        params: { id: record.stock_in_id }
      })
    },
    async destroy (record) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        record._deleting = true
        this.$store
          .dispatch('stockIn/destroy', record.stock_in_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    },
    dateRangeChange (dateRange) {
      this.$store.commit(
        'stockIn/SET_DATE_FROM',
        dateRange[0].format('DD-MM-YYYY')
      )
      this.$store.commit(
        'stockIn/SET_DATE_TO',
        dateRange[1].format('DD-MM-YYYY')
      )
      this.fetchData()
    },
    pdfView(record) {
      this.stockInId = record.stock_in_id
      this.pdf_view = true
    },
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500),
    branch_id: debounce(function (value) {
      this.fetchData({ branch_id: value })
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'stock-in-create') {
      this.$store.commit('stockIn/RESET_STATE')
    }
    next()
  }
}
</script>
